<template>
  <div class="wrapper">
    <div class="header">
      <p class="custom-title">{{ $t('journeyBuilder.form.CannotDisableTouchMode') }}</p>
    </div>
    <div class="content">
      <p class="touch-mode-alert">
        <template v-if="disableReason.regNotReq && disableReason.no_input">
          <span class="head-text">{{ $t('journeyBuilder.form.toDisableTouchModeMakeSure') }}</span>
          <ul>
            <li v-html="$t('journeyBuilder.form.eachFlowInJourneyMustHaveAtLeastOneInputMethodSelected')"/>
            <li v-html="$t('journeyBuilder.form.onlyOneFlowInJourneyHaveSingleRegistrationNotRequiredUserTypeSelected')"/>
          </ul>
        </template>
        <template v-else-if="disableReason.regNotReq && !getIsValidateRemoteJourney">
          <span class="head-text">{{ $t('journeyBuilder.form.journeyAssignedToNormalArea') }}</span>
          <ul>
            <li v-html="$t('journeyBuilder.form.atLeastOneFlowHaveInputMethodSelectedOtherThanMobileApp')"/>
            <li v-html="$t('journeyBuilder.form.onlyOneFlowHaveSingleRegistrationNotRequiredUserTypeSelected')"/>
          </ul>
        </template>

        <template v-else-if="disableReason.regNotReq">
          <span v-html="$t('journeyBuilder.form.toDisableTouchModeOnlyOneFlowHaveRegistrationNotRequiredUserType')" />
        </template>

        <template v-else-if="disableReason.no_input">
          <span v-html="$t('journeyBuilder.form.toDisableTouchModeEachFlowHaveOneInputMethod')" />
        </template>

        <template v-else-if="!getIsValidateRemoteJourney">
          <span v-html="$t('journeyBuilder.form.toDisableTouchModeHaveInputMethod')" />
        </template>

      </p>          
    </div>
    <hr class="h-line" />
    <div class="action-btns">
      <button @click="$bvModal.hide('touchModeAlert')" class="dismiss-action-btn btn btn-primary" size="md">
      {{ $t('common.okay') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TouchModeAlert",
  props: ["disableReason"],
  computed: {
    ...mapGetters("journey", [
      "getIsValidateRemoteJourney",
    ]),
  },
};
</script>

<style lang="scss">
  #touchModeAlert___BV_modal_content_ {
    margin-top: 326px !important;
    #touchModeAlert___BV_modal_body_ {
      position: fixed !important;
      margin: 0 !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      width: 500px !important;
      max-width: 90vw;
      border-radius: 26px;
      height: auto;
      min-width: 500px;
      background: white;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    .h-line {
      opacity: 0.15;
      background: #707070;
      width: 420px;
      margin: 0px auto 24px auto;
    }
    .action-btns {
      .dismiss-action-btn {
        background: #103f5e;
        border-radius: 16.6275px;
        width: 112px;
        height: 32px;
        color: #ffffff;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        text-align: center;
      }
    }

    .content ul {
      list-style: disc outside !important;
      margin-left: 24px;
      li{
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
        vertical-align: middle;
        color: #4A4A4A;
      }
    }

    .head-text{
      margin-bottom: 24px;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      vertical-align: middle;
      color: #4A4A4A;
    }
  }
  }
</style>
<style lang="scss" scoped>
  .header {
    margin-bottom: 40px;
    .custom-title {
      font-weight: 700;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: center;
      color: #000000;
    }
  }
  .close-icon {
    position: absolute;
    top: 21px;
    inset-inline-end: 26px;
    color: #f46a6a;
    font-size: 1.7rem;
    cursor: pointer;
  }
  .touch-mode-alert {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    color: #4A4A4A;
    margin-bottom: 40px !important;
  }
</style>
